import React, {
  createContext,
  useMemo
} from 'react';
import { number } from '@thd-nucleus/data-sources';
import proptypes from 'prop-types';
import { useConditionalPromotion } from '../hooks/useConditionalPromotion';

const {
  arrayOf, node, shape, string, bool
} = proptypes;

export const defaultModelContext = {
  rewardTiers: [{
    maxAllowedRewardAmount: 0,
    minThresholdVal: 0,
    thresholdType: '',
    rewardVal: 0,
    rewardType: '',
    rewardLevel: ''
  }],
  promotionTags: '',
  subExperience: '',
  sourceEligibilityCriteria: {},
  targetEligibilityCriteria: {}
};

export const PromoModelContext = createContext(defaultModelContext);

export const PromoModelProvider = ({
  itemId,
  promotion,
  children
}) => {

  const {
    subExperience,
    rewardTiers,
    sourceEligibilityCriteria,
    targetEligibilityCriteria
  } = useConditionalPromotion({ promotion });

  const contextValue = useMemo(() => {
    if (!promotion) {
      return {
        ...defaultModelContext
      };
    }
    return {
      itemId,
      subExperience,
      rewardTiers,
      sourceEligibilityCriteria,
      targetEligibilityCriteria
    };
  }, [
    promotion,
    itemId,
    subExperience,
    rewardTiers,
    sourceEligibilityCriteria,
    targetEligibilityCriteria
  ]);

  return (
    <PromoModelContext.Provider value={contextValue}>
      {(!promotion)
        ? (
          <div />
        ) : children}
    </PromoModelContext.Provider>
  );
};

PromoModelProvider.displayName = 'PromoModelProvider';

PromoModelProvider.propTypes = {
  itemId: string.isRequired,
  promotion: shape({
    promotionId: string,
    skuItemGroup: string,
    promotionTags: arrayOf(string),
    eligibilityCriteria: arrayOf(shape({
      itemGroup: string,
      minThresholdVal: number({ float: true }),
      thresholdType: string
    })),
    reward: shape({
      tiers: arrayOf(shape({
        minThresholdVal: number({ float: true }),
        thresholdType: string,
        rewardVal: number({ float: true }),
        rewardType: string,
        rewardLevel: string,
        maxAllowedRewardAmount: number({ float: true })
      }))
    })
  }).isRequired,
  children: node.isRequired
};
